import { Language } from '@/utils/language'
import Script from 'next/script'

export default ({ lang }: { lang: Language }) => {
  return (
    <>
      {/* Google Tag Manager (noscript)  */}
      <noscript>
        <iframe
          title="gtag-manager"
          src="https://www.googletagmanager.com/ns.html?id=GTM-WT3RGNW"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
      {/* End Google Tag Manager (noscript)  */}

      {/* Google Tag Manager */}
      <Script
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            ;(function (w, d, s, l, i) {
              w[l] = w[l] || []
              w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
              var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : ''
              j.async = true
              j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
              f.parentNode.insertBefore(j, f)
            })(window, document, 'script', 'dataLayer', 'GTM-WT3RGNW')
          `
        }}
      />
      {/* End Google Tag Manager  */}

      {/* Google tag (gtag.js)登录用户 */}
      <Script strategy="lazyOnload" async src="https://www.googletagmanager.com/gtag/js?id=G-F9R54EGLQV" />

      {/* Google tag (gtag.js) */}
      <Script strategy="lazyOnload" async src="https://www.googletagmanager.com/gtag/js?id=UA-233959850-1" />
      {/* Google tag (gtag.js)北京銥氪科技有限责任公司 */}
      <Script strategy="lazyOnload" async src="https://www.googletagmanager.com/gtag/js?id=AW-11015810512" />
      <Script
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){
            dataLayer.push(arguments);
          }
          gtag('js', new Date());
        
          gtag('config', 'AW-11015810512', { 'allow_enhanced_conversions': true });
          `
        }}
      />

      {/* Intercom */}
      <Script
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/jr0fp2wt'
            ;(function () {
              var w = window
              var ic = w.Intercom
              if (typeof ic === 'function') {
                ic('reattach_activator')
                ic('update', w.intercomSettings)
              } else {
                var d = document
                var i = function () {
                  i.c(arguments)
                }
                i.q = []
                i.c = function (args) {
                  i.q.push(args)
                }
                w.Intercom = i
                var l = function () {
                  var s = d.createElement('script')
                  s.type = 'text/javascript'
                  s.async = true
                  s.src = 'https://widget.intercom.io/widget/jr0fp2wt'
                  var x = d.getElementsByTagName('script')[0]
                  x.parentNode.insertBefore(s, x)
                }
                if (document.readyState === 'complete') {
                  l()
                } else if (w.attachEvent) {
                  w.attachEvent('onload', l)
                } else {
                  w.addEventListener('load', l, false)
                }
              }
            })()
          `
        }}
      />

      <Script
        strategy="lazyOnload"
        id="cookieyes"
        async
        src="https://cdn-cookieyes.com/client_data/1575744314c042d6d352e2a3/script.js"
      />

      <Script
        strategy="lazyOnload"
        id="baidu-agl"
        dangerouslySetInnerHTML={{
          __html: `
              window._agl = window._agl || [];
              (function () {
                _agl.push(
                  ['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
                );
                (function () {
                  var agl = document.createElement('script');
                  agl.type = 'text/javascript';
                  agl.async = true;
                  agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
                  var s = document.getElementsByTagName('script')[0];
                  s.parentNode.insertBefore(agl, s);
                })();
              })();
            `
        }}
      />

      <Script
        id="baidu"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `
              var _hmt = _hmt || [];
              (function() {
                var hm = document.createElement("script");
                hm.src = "https://hm.baidu.com/hm.js?a19dc14c14357c20224d43189684bf8c";
                var s = document.getElementsByTagName("script")[0]; 
                s.parentNode.insertBefore(hm, s);
              })();
            `
        }}
      />

      {/* Meta Pixel Code */}
      <Script
        id="meta-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '449222451523674');
  fbq('track', 'PageView');
          `
        }}
      />
      {/* ts-ignore */}
      <noscript>
        {/* eslint-disable-next-line */}
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=449222451523674&ev=PageView&noscript=1"
        />
      </noscript>
      {/* End Meta Pixel Code */}

      {/* 奇虎360事件 */}
      {/* <Script
        id="qh360"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(b,a,e,h,f,c,g,s){b[h]=b[h]||function(){(b[h].c=b[h].c||[]).push(arguments)};
            b[h].s=!!c;g=a.getElementsByTagName(e)[0];s=a.createElement(e);
            s.src="//s.union.360.cn/"+f+".js";s.defer=!0;s.async=!0;g.parentNode.insertBefore(s,g)
            })(window,document,"script","_qha",562609,false);
            `
        }}
      /> */}
    </>
  )
}
